import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { JXitemJson } from '@/views/system/homePage/server';

export interface HomePagesJXState {
  JXlist: JXitemJson[];
}

const HOMEPAGE_KEY = 'React-ts-ant-homePage-JXlist';

const localHomePages = LocalStore.getValue<HomePagesJXState>(HOMEPAGE_KEY) || {};

export const defaults: HomePagesJXState = {
  JXlist: [],
  ...localHomePages
};

const HOME_PAGE_KEY = 'React-ts-ant-homePage-JXlist';

export const updateHomePagesJX: (homePages: HomePagesJXState) => IAction<HomePagesJXState> = (
  homePages: HomePagesJXState
) => ({
  type: HOME_PAGE_KEY,
  payload: homePages
});

const homeJXList: Reducer<HomePagesJXState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case HOME_PAGE_KEY:
      LocalStore.setValue(HOMEPAGE_KEY, payload as HomePagesJXState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default homeJXList;
